import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { LoginResponse, User } from '../../../core/interfaces/user/user.interface';
import { StorageService } from '../../../core/service/storage.service';
import { AuthService } from '../../../core/service/auth.service';
import { Store } from '@ngrx/store';
import { resetBalance } from '../../../features/perfil-user/store/balance.actions';
import { resetShipping } from '../../../store/shipping/shipping.actions';

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  private readonly apiUrl = environment.apiUrl;
  private readonly TOKEN_KEY = 'auth_token';
  private readonly USER_KEY = 'user';

  constructor(
    private http: HttpClient,
    private storageService: StorageService,
    private authService: AuthService,
    private store: Store
  ) { }

  login(email: string, password: string): Observable<LoginResponse> {
    return this.http.post<LoginResponse>(`${this.apiUrl}/login`, { email, password })
      .pipe(
        tap(response => {
          if (response.status && response.data) {
            // Guardar token
            this.storageService.setItem(this.TOKEN_KEY, response.data.token);
            // Guardar datos del usuario
            this.storageService.setItem(this.USER_KEY, response.data);
          }
        })
      );
  }

  logout(): Observable<any> {
    const token = this.getToken();
    const headers = token ?
      { headers: new HttpHeaders().set('Authorization', `Bearer ${token}`) } : {};

    return this.http.post<any>(`${this.apiUrl}/logout`, {}, headers)
      .pipe(
        tap(() => {
          // Limpiar el estado de NgRx
          this.store.dispatch(resetBalance());
          this.store.dispatch(resetShipping());

          // Clear storage after successful logout
          this.authService.clearAuth(); // Limpia tokens, datos de usuario y dirección seleccionada
          this.storageService.clear(); // Limpiar todo el almacenamiento local del navegador para asegurar

          // Limpiar sessionStorage manualmente para asegurar que se elimine appState
          sessionStorage.removeItem('appState');
        })
      );
  }

  isLoggedIn(): boolean {
    return this.storageService.hasItem(this.TOKEN_KEY);
  }

  getUser(): User | null {
    return this.storageService.getItem<User>(this.USER_KEY);
  }

  getToken(): string | null {
    return this.storageService.getItem(this.TOKEN_KEY);
  }
}
